// extracted by mini-css-extract-plugin
export default {"container":"ZJsCBRRVxKlkbhQ1Euk0","cardsGrid":"czqFsRV6W1ElBRMgo4ob"};